import { shapes } from "../../../../styles/icons";
import { DrawingModuleContainer } from "../../ModuleBase/DrawingModuleContainer";
import { DrawShapesCircModule } from "./shapes-circ-module";
import { DrawShapesElpsModule } from "./shapes-elps-module";
import { DrawShapesSqreModule } from "./shapes-sqre-module";
import { DrawShapesRectModule } from "./shapes-rect-module";
import { DrawShapesTriaModule } from "./shapes-tria-module";

export class DrawShapesModuleContainer extends DrawingModuleContainer {
	constructor(canvas, getColor, drawingHistory) {
		super(canvas);

		this.moduleId = "shape";
		this.toolbarWidth = "40px";
		this.icon = shapes;
		this.label = "shape";

		this.submodules.push(new DrawShapesRectModule(canvas, getColor, drawingHistory));
		this.submodules.push(new DrawShapesSqreModule(canvas, getColor, drawingHistory));
		this.submodules.push(new DrawShapesElpsModule(canvas, getColor, drawingHistory));
		this.submodules.push(new DrawShapesCircModule(canvas, getColor, drawingHistory));
		this.submodules.push(new DrawShapesTriaModule(canvas, getColor, drawingHistory));
	}
}

window.customElements.define(
	"inspx-draw-shapes-container",
	DrawShapesModuleContainer
);
